var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    dialogId: null,
    subscribedDialogs: [],
    isDialogLoading: false,
    error: null,
    formSubmit: null,
};
var dialogSlice = createSlice({
    name: 'dialog',
    initialState: initialState,
    reducers: {
        getListDialog: function (state, action) {
            return __assign(__assign({}, state), { subcribedDialogs: action.payload });
        },
        subscribeDialog: function (state, action) {
            return __assign(__assign({}, state), { subscribedDialogs: action.payload });
        },
        submitDialogForm: function (state, action) {
            return __assign(__assign({}, state), { formSubmit: action.payload });
        },
        openDialog: function (state, action) {
            return __assign(__assign({}, state), { dialogId: action.payload });
        },
        closeDialog: function (state) {
            return __assign(__assign({}, state), { dialogId: null, subcribedDialogs: [] });
        },
    },
});
export var getListDialog = (_a = dialogSlice.actions, _a.getListDialog), subscribeDialog = _a.subscribeDialog, openDialog = _a.openDialog, closeDialog = _a.closeDialog, submitDialogForm = _a.submitDialogForm;
export default dialogSlice.reducer;
